import { createStore } from 'vuex'

export default createStore({
  state: {
    logged: false,
    user: null,
    errorObject: null,
    successObject: null,
    formState: {},
  },

  getters: {},

  mutations: {
    setLogged(state, statusLogged) {
      state.logged = statusLogged
    },
    setUser(state, user) {
      state.user = user
    },

    setError(state, object) {
      state.errorObject = object
    },
    setSuccess(state, object) {
      state.successObject = object
    },
    setFormState(state, object) {
      state.formState = object
    },
  },

  actions: {
    setLogged({ commit }, statusLogged) {
      commit('setLogged', statusLogged)
    },
    setUser({ commit }, user) {
      commit('setUser', user)
    },
    setError({ commit }, object) {
      commit('setError', object)
    },
    setSuccess({ commit }, object) {
      commit('setSuccess', object)
    },
    setToastMessage({ commit }, object) {
      commit('setSuccess', object)
    },
    setForm({ commit }, object) {
      commit('setFormState', object)
    },
  },

  modules: {},
})
